import {
  dashboardContentTypeFromPathSegment,
  dashboardPathForContentType,
  defaultDashboardContentType,
} from "@dashboard/navigation/dashboardRoutes"
import { createFileRoute, redirect } from "@tanstack/react-router"
import { lazy, Suspense } from "react"

const DashboardApp = lazy(() =>
  import("@dashboard/components/DashboardApp").then((module) => ({ default: module.DashboardApp }))
)

export const Route = createFileRoute("/dashboard/$section")({
  component: DashboardSectionRoute,
  beforeLoad: ({ params }) => {
    const type = dashboardContentTypeFromPathSegment(params.section)
    if (!type) {
      throw redirect({ href: dashboardPathForContentType(defaultDashboardContentType) })
    }
  },
})

function DashboardSectionRoute() {
  const { section } = Route.useParams()
  const type = dashboardContentTypeFromPathSegment(section) ?? defaultDashboardContentType

  return (
    <Suspense fallback={<div className="dashboard-loading">Loading dashboard...</div>}>
      <DashboardApp activeType={type} />
    </Suspense>
  )
}
